import React, { useEffect, useState } from "react";
import pago2 from "../../assets/iconos/pago2.png";
import bcp from "../../assets/iconos/bcp.png";
import interbank from "../../assets/iconos/interbank.png";
import bbva from "../../assets/iconos/bbva.png";
import scotiabank from "../../assets/iconos/scotiabank.png";
import useMatricula from "../../hooks/useMatricula";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import useAuth from "../../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../../utils/idioma/LabelsIdioma";
import {
  listaBancos,
  listaModalidadPagos,
  listaPensionesCuotasPendientes,
  updateDatosPago,
  validacionEstadoPagoMatricula,
} from "../../services/Pagos";


const PagoPensiones = () => {
  let {
    setPasoProcesoM,
    setPasoSegundaVistaProcesoM,
    listaPensionesEstudiante,
    setPensionesEstudiante,
    setLoading,
    listadoBancos,
    setListadoBancos,
    setListadoModalidadPagos,
    listadoModalidadPagos,
  } = useProcesoMatricula();

  let {
    obtenerDatosEstudiante,
  } = useMatricula();

  const [checkedState, setCheckedState] = useState(false);
  const [total, setTotal] = useState(0);

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const [contarCargaTotal, setContarCargaTotal] = useState(0);
  const [disableBotonPensiones, setDisableBotonPensiones] = useState(true);
  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);
    const totalPrice = updatedCheckedState.reduce(
      (sum, currentState, index) => {
        if (currentState === true) {
          return sum + listaPensionesEstudiante[index].nsaldo;
        }
        return sum;
      },
      0
    );
    setTotal(totalPrice);
  };


  const validarBtnPagoAhora = async () => {
    //Pago de tienda upch
    try {
      const { ndocidentidad } = obtenerDatosEstudiante;

    } catch (error) {
      document.querySelector("#bntErrorToken")?.click();
    } finally {
    }
  };

  const formatterDate = (dateToFormatter) => {
    let dateResolve = new Date(dateToFormatter);
    dateResolve = `${dateResolve.getDate()}/${dateResolve.getMonth() + 1 < 10
      ? "0" + (Number(dateResolve.getMonth()) + 1)
      : Number(dateResolve.getMonth()) + 1
      }/${dateResolve.getFullYear()}`;
    return dateResolve;
  };

  const validarBtnPagoDespues = () => {
    //Primero validar

    //Despues setear los campos de estado
    setPasoProcesoM(5);
    setPasoSegundaVistaProcesoM(false);
  };

  const {
    global_pago,
    pago_cuotas,
    pago_modalidad_pago,
    pago_matricula,
    pago_pension_semestral,
    pago_otros,
    pago_msj_total_neto,
    pago_msj_primer,
    pago_msj_restantes,
    pago_monto_cuota,
    pago_seleccion_pensiones,
    pago_nro_serie,
    pago_nro_doc,
    pago_fecha_emision,
    global_fecha_vencimiento,
    pago_moneda,
    pago_saldo,
    pago_total_pagar,
    pago_msj_seleccione_metodo,
    pago_en_linea,
    pago_tarjeta_credito_debito,
    pago_pagar_ahora,
    pago_banco,
    pago_efectivo,
    pago_generar_codigo,
    pago_banca_internet,
    pago_msj_matricula_pensiones,
    pago_pasos_seguir,
    pago_msj_ingresar_pagina,
    pago_msj_selecionar_operaciones,
    pago_msj_numero,
    pago_msj_marca_opcion,
    pago_msj_seleccion_institucion,
    pago_msj_indicar_modalidad,
    pago_msj_clave_token,
    pago_msj_continuar_pago,
    pago_pagar_despues,
    pago_msj_efectivo,
    pago_msj_indicar_cajero,
    pago_msj_codigo_alumno,
    pago_msj_bancos,
    pago_deuda_total,
    pago_msj_universidad,
    pago_msj_pago_matricula,
    pago_agencias_bancarias,
  } = etiquetas || "";

  function separator(numb) {
    var str = numb.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
  }

  const { nnumeroserie, numerodoc, femision, fvencimiento, cmoneda, nsaldo } =
    listaPensionesEstudiante || "";

  let selector = `#${nnumeroserie + numerodoc + fvencimiento}`;

  let deudaTotal = () => {
    let deuda = 0;
    listaPensionesEstudiante.map((data, index) => {
      deuda += Number(data.nsaldo);
    });

    return deuda.toFixed(2);
  };

  useEffect(() => {
    setCheckedState(new Array(listaPensionesEstudiante.length).fill(false));
    setDisableBotonPensiones(false)
  }, [listaPensionesEstudiante]);

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_pago: obtenerLabelEtiqueta("lbl_global_pago", listadoEtiquetas),
        pago_cuotas: obtenerLabelEtiqueta("lbl_pago_cuotas", listadoEtiquetas),
        pago_modalidad_pago: obtenerLabelEtiqueta(
          "lbl_pago_modalidad_pago",
          listadoEtiquetas
        ),
        pago_matricula: obtenerLabelEtiqueta(
          "lbl_pago_matricula",
          listadoEtiquetas
        ),
        pago_pension_semestral: obtenerLabelEtiqueta(
          "lbl_pago_pension_semestral",
          listadoEtiquetas
        ),
        pago_otros: obtenerLabelEtiqueta("lbl_pago_otros", listadoEtiquetas),
        pago_msj_total_neto: obtenerLabelEtiqueta(
          "lbl_pago_msj_total_neto",
          listadoEtiquetas
        ),
        pago_msj_primer: obtenerLabelEtiqueta(
          "lbl_pago_msj_primer",
          listadoEtiquetas
        ),
        pago_msj_restantes: obtenerLabelEtiqueta(
          "lbl_pago_msj_restantes",
          listadoEtiquetas
        ),
        pago_monto_cuota: obtenerLabelEtiqueta(
          "lbl_pago_monto_cuota",
          listadoEtiquetas
        ),
        pago_seleccion_pensiones: obtenerLabelEtiqueta(
          "lbl_pago_seleccion_pensiones",
          listadoEtiquetas
        ),
        pago_nro_serie: obtenerLabelEtiqueta(
          "lbl_pago_nro_serie",
          listadoEtiquetas
        ),
        pago_nro_doc: obtenerLabelEtiqueta(
          "lbl_pago_nro_doc",
          listadoEtiquetas
        ),
        pago_fecha_emision: obtenerLabelEtiqueta(
          "lbl_pago_fecha_emision",
          listadoEtiquetas
        ),
        global_fecha_vencimiento: obtenerLabelEtiqueta(
          "lbl_global_fecha_vencimiento",
          listadoEtiquetas
        ),
        pago_moneda: obtenerLabelEtiqueta("lbl_pago_moneda", listadoEtiquetas),
        pago_saldo: obtenerLabelEtiqueta("lbl_pago_saldo", listadoEtiquetas),
        pago_total_pagar: obtenerLabelEtiqueta(
          "lbl_pago_total_pagar",
          listadoEtiquetas
        ),
        pago_msj_seleccione_metodo: obtenerLabelEtiqueta(
          "lbl_pago_msj_seleccione_metodo",
          listadoEtiquetas
        ),
        pago_en_linea: obtenerLabelEtiqueta(
          "lbl_pago_en_linea",
          listadoEtiquetas
        ),
        pago_tarjeta_credito_debito: obtenerLabelEtiqueta(
          "lbl_pago_tarjeta_credito_debito",
          listadoEtiquetas
        ),
        pago_pagar_ahora: obtenerLabelEtiqueta(
          "lbl_pago_pagar_ahora",
          listadoEtiquetas
        ),
        pago_banco: obtenerLabelEtiqueta("lbl_pago_banco", listadoEtiquetas),
        pago_efectivo: obtenerLabelEtiqueta(
          "lbl_pago_efectivo",
          listadoEtiquetas
        ),
        pago_generar_codigo: obtenerLabelEtiqueta(
          "lbl_pago_generar_codigo",
          listadoEtiquetas
        ),
        pago_banca_internet: obtenerLabelEtiqueta(
          "lbl_pago_banca_internet",
          listadoEtiquetas
        ),
        pago_msj_matricula_pensiones: obtenerLabelEtiqueta(
          "lbl_pago_msj_matricula_pensiones",
          listadoEtiquetas
        ),
        pago_pasos_seguir: obtenerLabelEtiqueta(
          "lbl_pago_pasos_seguir",
          listadoEtiquetas
        ),
        pago_msj_ingresar_pagina: obtenerLabelEtiqueta(
          "lbl_pago_msj_ingresar_pagina",
          listadoEtiquetas
        ),
        pago_msj_selecionar_operaciones: obtenerLabelEtiqueta(
          "lbl_pago_msj_selecionar_operaciones",
          listadoEtiquetas
        ),
        pago_msj_numero: obtenerLabelEtiqueta(
          "lbl_pago_msj_numero",
          listadoEtiquetas
        ),
        pago_msj_marca_opcion: obtenerLabelEtiqueta(
          "lbl_pago_msj_marca_opcion",
          listadoEtiquetas
        ),
        pago_msj_seleccion_institucion: obtenerLabelEtiqueta(
          "lbl_pago_msj_seleccion_institucion",
          listadoEtiquetas
        ),
        pago_msj_indicar_modalidad: obtenerLabelEtiqueta(
          "lbl_pago_msj_indicar_modalidad",
          listadoEtiquetas
        ),
        pago_msj_clave_token: obtenerLabelEtiqueta(
          "lbl_pago_msj_clave_token",
          listadoEtiquetas
        ),
        pago_msj_continuar_pago: obtenerLabelEtiqueta(
          "lbl_pago_msj_continuar_pago",
          listadoEtiquetas
        ),
        pago_pagar_despues: obtenerLabelEtiqueta(
          "lbl_pago_pagar_despues",
          listadoEtiquetas
        ),
        pago_msj_efectivo: obtenerLabelEtiqueta(
          "lbl_pago_msj_efectivo",
          listadoEtiquetas
        ),
        pago_msj_indicar_cajero: obtenerLabelEtiqueta(
          "lbl_pago_msj_indicar_cajero",
          listadoEtiquetas
        ),
        pago_msj_universidad: obtenerLabelEtiqueta(
          "lbl_pago_msj_universidad",
          listadoEtiquetas
        ),
        pago_msj_codigo_alumno: obtenerLabelEtiqueta(
          "lbl_pago_msj_codigo_alumno",
          listadoEtiquetas
        ),
        pago_msj_bancos: obtenerLabelEtiqueta(
          "lbl_pago_msj_bancos",
          listadoEtiquetas
        ),
        pago_deuda_total: obtenerLabelEtiqueta(
          "lbl_pago_deuda_total",
          listadoEtiquetas
        ),
        pago_msj_pago_matricula: obtenerLabelEtiqueta(
          "lbl_pago_msj_pago_matricula",
          listadoEtiquetas
        ),
        pago_agencias_bancarias: obtenerLabelEtiqueta(
          "lbl_pago_agencias_bancarias",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  useEffect(() => {
    listaModalidadPagos(
      obtenerDatosEstudiante,
      setListadoModalidadPagos,
      setLoading
    );

    listaBancos(obtenerDatosEstudiante, setListadoBancos);
    setContarCargaTotal(0);
  }, []);

  useEffect(() => {
    setLoading(true);
    setDisableBotonPensiones(true)
    const { ndocidentidad } = obtenerDatosEstudiante;
    if (ndocidentidad) {
      let carritoSeguro = 0;
      listaPensionesCuotasPendientes(
        { ndocidentidad, carritoSeguro },
        setPensionesEstudiante,
        setLoading
      );
    }
  }, [obtenerDatosEstudiante]);

  const handleValidarPensiones = () => {
    setDisableBotonPensiones(true)

    const { ndocidentidad } = obtenerDatosEstudiante;
    if (ndocidentidad) {
      let carritoSeguro = 0;
      listaPensionesCuotasPendientes(
        { ndocidentidad, carritoSeguro },
        setPensionesEstudiante,
        setLoading
      );
    }
  }

  const handleValidacionDePago = async () => {
    const { ndocidentidad, sprograma, dperiodo } = obtenerDatosEstudiante;

    if (dperiodo) {
      try {
        setLoading(true);


        let validacionEstado = await validacionEstadoPagoMatricula(
          dperiodo,
          sprograma,
          ndocidentidad,
          setLoading
        );

        if (validacionEstado.Code === "1" || validacionEstado.Code === "2") {
          let updatePago = await updateDatosPago(
            obtenerDatosEstudiante,
            setLoading,
            { paso: 5, pasoPago: 2 }
          );
          if (updatePago.Message === "OK") {
            setPasoProcesoM(5);
            setPasoSegundaVistaProcesoM(true);
          }
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };
  const { cuotas_restante, primer_monto, valor_cuota } =
    listadoModalidadPagos || {};

  let cuotasPagara =
    cuotas_restante !== 0 ? cuotas_restante + 1 : cuotas_restante;
  let retornameImagen = (cimagen) => {
    let ruta;
    switch (cimagen) {
      case "bcp.png":
        ruta = bcp;
        break;
      case "interbank.png":
        ruta = interbank;
        break;
      case "bbva.png":
        ruta = bbva;
        break;
      case "scotiabank.png":
        ruta = scotiabank;
        break;
      default:
        ruta = "";
        break;
    }
    return ruta;
  };
  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <button
        id="bntErrorToken"
        data-bs-toggle="modal"
        data-bs-target="#errorGenerarToken"
        style={{ display: "none" }}
      ></button>
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <div className="form-body pago-body">
              <div className="matricula-title">
                <h5 className="text-uppercase">{global_pago}</h5>
                <div className="separator"></div>
              </div>
              <p className="text-uppercase fw-bolder mt-4">
                {cuotasPagara != 0 &&
                  pago_modalidad_pago + " " + cuotasPagara + " " + pago_cuotas}

                {cuotasPagara == 0 && "MODALIDAD DE PAGO AL CONTADO"}

              </p>

              <div
                className="table-responsive table-schedule "
                id="no-more-tables"
              >
                <table className="table table-striped">
                  <thead className="table-light">
                    <tr>


                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_msj_primer}
                      </th>

                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_msj_restantes}
                      </th>
                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_monto_cuota}
                      </th>
                    </tr>
                  </thead>

                  <tfoot>
                    <tr>


                      <th style={{ textAlign: "right", fontWeight: 400 }}>
                        {primer_monto}
                      </th>
                      <td style={{ textAlign: "right" }}>{cuotas_restante}</td>
                      <td style={{ textAlign: "right" }}>{valor_cuota}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="d-flex w-full justify-content-between mb-2">
                <p className="text-uppercase fw-bolder mt-4">
                  {pago_seleccion_pensiones}
                </p>

                <div className="mt-4">
                  <button
                    className="btn btn-outline-danger btn-sm px-4"
                    onClick={handleValidarPensiones}
                    disabled={disableBotonPensiones}
                  >
                    <i className="bi bi-arrow-clockwise text-upch me-1" />{" "}
                    Ver pensiones
                  </button>
                </div>
              </div>

              <div className="table-schedule table-pensiones">
                <table className="table table-striped col-sm-12">
                  <thead className="table-light">
                    <tr>

                      <th scope="col" style={{ textAlign: "left" }}>
                        Tipo de Pago
                      </th>
                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_nro_serie}
                      </th>
                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_nro_doc}
                      </th>

                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_fecha_emision}
                      </th>
                      <th scope="col" style={{ textAlign: "right" }}>
                        {global_fecha_vencimiento}
                      </th>

                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_moneda}
                      </th>

                      <th scope="col" style={{ textAlign: "right" }}>
                        {pago_saldo}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaPensionesEstudiante.map((data, index) => {
                      return (
                        <tr key={index}>

                          <th style={{ textAlign: "left", fontWeight: 400 }}>
                            {data.tipo_pago}
                          </th>
                          <td style={{ textAlign: "right" }}>
                            {data.nroserie}
                          </td>
                          <td style={{ textAlign: "right" }}> {data.numdoc}</td>
                          <td style={{ textAlign: "right" }}>

                            {data.femision}
                          </td>
                          <td style={{ textAlign: "right" }}>

                            {data.fvencimiento}
                          </td>
                          <td style={{ textAlign: "right" }}>{data.moneda}</td>
                          <td style={{ textAlign: "right" }}>{data.nsaldo}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>

                      <th colSpan="4"> </th>
                      <td style={{ textAlign: "right" }}>
                        {" "}
                        {pago_deuda_total}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {" "}
                        {listaPensionesEstudiante.length > 0 &&
                          listaPensionesEstudiante[0].moneda}
                      </td>
                      <td style={{ textAlign: "right" }}>{deudaTotal()}</td>
                    </tr>

                  </tfoot>
                </table>
              </div>
              <div
                className="accordion  accordion-pensiones d-none"
                id="accordionExamplePension"
              >
                {listaPensionesEstudiante.map((data, index) => {
                  return (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={selector}
                          aria-expanded="false"
                          aria-controls={`${nnumeroserie + numerodoc + fvencimiento
                            }`}
                        >

                          <span>
                            {pago_nro_serie}: {data.nroserie}
                          </span>
                        </button>
                      </h2>
                      <div
                        id={`${nnumeroserie + numerodoc + fvencimiento}`}
                        className="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExamplePension"
                      >
                        <div className="accordion-body">
                          <div className="d-flex justify-content-between py-1 px-3 border-bottom">
                            <p className="fw-medium mb-0">{pago_nro_doc}</p>
                            <p className="mb-0">{data.numdoc}</p>
                          </div>
                          <div className="d-flex justify-content-between py-1 px-3 border-bottom">
                            <p className="fw-medium mb-0">
                              {pago_fecha_emision}
                            </p>
                            <p className="mb-0">

                              {data.femision}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between py-1 px-3 border-bottom">
                            <p className="fw-medium mb-0">
                              {global_fecha_vencimiento}
                            </p>
                            <p className="mb-0">

                              {data.fvencimiento}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between py-1 px-3 border-bottom">
                            <p className="fw-medium mb-0">{pago_moneda}</p>
                            <p className="mb-0">{data.moneda}</p>
                          </div>
                          <div className="d-flex justify-content-between py-1 px-3 ">
                            <p className="fw-medium mb-0">{pago_saldo}</p>
                            <p className="mb-0">{data.nsaldo}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="accordion-pensiones d-none border rounded-3">
                <div className="d-flex justify-content-between py-1 px-3">
                  <p className="fw-medium mb-0">{pago_deuda_total}</p>
                  <p className="fw-medium mb-0">{deudaTotal()}</p>
                </div>

              </div>
              <p className="text-uppercase fw-bolder mt-4">
                {pago_msj_seleccione_metodo}
              </p>

              <div className="my-3">
                <div className="mt-4">
                  <div className="alert alert-warning" role="alert">
                    <p className="mb-0" style={{ lineHeight: "1.2" }}>
                      <svg
                        style={{ width: 24, height: 24, marginRight: 5 }}
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                        />
                      </svg>
                      Si el pago es realizado por fuera de la plataforma, deberá
                      refrescar esta página, y cuando detecte el pago
                      confirmaremos su matrícula.
                    </p>
                    <div className="mt-4">
                      <a
                        className="btn btn-outline-danger btn-sm px-4"
                        onClick={handleValidacionDePago}
                      >
                        <i className="bi bi-arrow-clockwise text-upch me-1" />{" "}
                        Validar Pago
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="accordion  accordion-payment"
                id="accordionExample"
              >


                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      <i className="fa-solid fa-building-columns me-2"></i>{" "}
                      {pago_banco}
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div
                        className="accordion accordion-flush"
                        id="accordionFlushExample"
                      >


                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id="flush-headingTwo"
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseTwo"
                              aria-expanded="false"
                              aria-controls="flush-collapseTwo"
                            >
                              <div className="d-flex py-2 mb-1">
                                <div className="form-check-inline va-middle ms-3 justify-content-start w-190">
                                  <input
                                    type="radio"
                                    name="styles"
                                    id="box-shadow"
                                    className="custom-radio form-seguro form-check-input"
                                  />
                                  <label className="ms-3 fw-medium mb-0 pt-1 text-black  ">
                                    {pago_banca_internet}
                                  </label>
                                </div>

                                <img
                                  alt="Efectivo"
                                  src={pago2}
                                  style={{ paddingTop: "10px" }}
                                />
                              </div>
                            </button>
                          </h2>
                          <div
                            id="flush-collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="flush-headingTwo"
                            data-bs-parent="#accordionFlushExample"
                          >
                            <div className="accordion-body">
                              <div className="px-4 pt-4">
                                <p className="text-uppercase fw-bolder fs-reg mb-0">
                                  {pago_msj_matricula_pensiones}
                                </p>
                                <p className="fs-sm fw-regular">
                                  {pago_msj_efectivo}
                                </p>
                                <nav>
                                  <div
                                    className="nav nav-tabs bancos justify-content-between"
                                    id="nav-tab"
                                    role="tablist"
                                  >
                                    {listadoBancos.map((lbancos, index) => {
                                      if (lbancos.ntipo !== 4) {
                                        return (
                                          <button
                                            key={index}
                                            className={`nav-link ${index == 0 ? "active" : ""
                                              }`}
                                            id={`nav-${index}-tab`}
                                            data-bs-toggle="tab"
                                            data-bs-target={`#nav-${index}`}
                                            type="button"
                                            role="tab"
                                            aria-controls={`nav-${index}`}
                                            aria-selected={
                                              index == 0 ? true : false
                                            }
                                          >
                                            <img
                                              src={retornameImagen(
                                                lbancos.cimagen
                                              )}
                                              className="me-2"
                                              alt=""
                                            />
                                            <span>{lbancos.ddescripcion}</span>
                                          </button>
                                        );
                                      }
                                    })}
                                  </div>
                                </nav>
                                <div
                                  className="tab-content"
                                  id="nav-tabContent"
                                >
                                  {listadoBancos.map((lbancos, index) => {
                                    if (lbancos.ntipo !== 4) {
                                      return (
                                        <div
                                          key={index}
                                          className={`tab-pane fade ${index == 0 && "show active"
                                            }`}
                                          id={`nav-${index}`}
                                          role="tabpanel"
                                          aria-labelledby={`nav-${index}-tab`}
                                        >
                                          <div
                                            className="border rounded-3 mt-4 mb-2 py-2 px-3"
                                            dangerouslySetInnerHTML={{
                                              __html: lbancos.dtexto,
                                            }}
                                          ></div>
                                        </div>
                                      );
                                    }
                                  })}


                                </div>
                              </div>
                              <div className="px-4 py-1">
                                <p className="fw-regular mb-0 fs-sm">
                                  {pago_msj_continuar_pago}.
                                </p>
                              </div>
                              <div className="text-center mt-3">
                                <button
                                  type="button"
                                  className="btn waves-effect waves-light btn-light-secondary bg-black previous mb-4"
                                  onClick={validarBtnPagoDespues}
                                >
                                  {pago_pagar_despues}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id="flush-headingThree"
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseThree"
                              aria-expanded="false"
                              aria-controls="flush-collapseThree"
                            >
                              <div className="d-flex py-2 mb-1">
                                <div className="form-check-inline va-middle ms-3 justify-content-start w-190">
                                  <input
                                    type="radio"
                                    name="styles"
                                    id="box-shadow"
                                    className="custom-radio form-seguro form-check-input"
                                  />
                                  <label className="ms-3 fw-medium mb-0 pt-1 text-black  ">
                                    Cajas Cayetano
                                  </label>
                                </div>
                              </div>
                            </button>
                          </h2>
                          <div
                            id="flush-collapseThree"
                            className="accordion-collapse collapse"
                            aria-labelledby="flush-headingThree"
                            data-bs-parent="#accordionFlushExample"
                          >
                            <div className="accordion-body">
                              <div className="p-4">
                                <p className="text-uppercase fw-bolder fs-reg mb-3">
                                  PAGO EN CAJAS CAYETANO
                                </p>
                                <div className="border rounded-3 mb-2 py-2 px-3 ">
                                  <p className="fw-bold pt-1">
                                    Pasos a seguir:
                                  </p>
                                  <p className="fw-regular">
                                    También puedes acercarte a las cajas de la
                                    universidad, ubicadas en las diferentes
                                    sedes:
                                    <br />
                                    <br />
                                  </p>
                                  <div className="d-flex gap-1 justify-content-between">
                                    <div className="w-25 sede-div">
                                      <div className="text-center mb-2">
                                        <h4>
                                          <i className="bi bi-geo-alt text-upch me-1" />
                                        </h4>
                                        <span className="fw-medium">
                                          Caja Sede San Martín de Porres:
                                        </span>
                                      </div>
                                      <div className="text-center">
                                        <p className="fw-regular text-center mb-0">
                                          - Lunes a viernes de 8:00 a.m. a 4:45
                                          p.m.{" "}
                                        </p>
                                        <p className="fw-regular text-center">
                                          - Sábados de 8:00 a.m. a 1:00 p.m.
                                        </p>
                                      </div>
                                    </div>
                                    <div className="w-25 sede-div">
                                      <div className="text-center mb-2">
                                        <h4>
                                          <i className="bi bi-geo-alt text-upch me-1" />
                                        </h4>
                                        <span className="fw-medium">
                                          Caja Sede Salaverry:
                                        </span>
                                      </div>
                                      <div className="text-center">
                                        <p className="fw-regular text-center mb-0">
                                          - Lunes a viernes de 8:00 a.m. a 8:00
                                          p.m.{" "}
                                        </p>
                                        <p className="fw-regular text-center">
                                          - Sábados de 8:00 a.m. a 4:45 p.m.
                                        </p>
                                      </div>
                                    </div>
                                    <div className="w-25 sede-div">
                                      <div className="text-center mb-2">
                                        <h4>
                                          <i className="bi bi-geo-alt text-upch me-1" />
                                        </h4>
                                        <span className="fw-medium">
                                          Caja Sede Miraflores:
                                        </span>
                                      </div>
                                      <div className="text-center">
                                        <p className="fw-regular text-center mb-0">
                                          - Lunes a viernes de 10:00 a.m. a 7:00
                                          p.m.
                                        </p>
                                        <p className="fw-regular text-center">
                                          - Sábados de 9:00 a.m. a 3:00 p.m.
                                        </p>
                                      </div>
                                    </div>
                                    <div className="w-25 sede-div">
                                      <div className="text-center mb-2">
                                        <h4>
                                          <i className="bi bi-geo-alt text-upch me-1" />
                                        </h4>
                                        <span className="fw-medium">
                                          Caja Sede La Molina:
                                        </span>
                                      </div>
                                      <div className="text-center">
                                        <p className="fw-regular text-center mb-0">
                                          - Lunes a viernes de 8:00 a.m. a 5:45
                                          p.m.{" "}
                                        </p>
                                        <p className="fw-regular text-center">
                                          - Sábados de 9:00 a.m. a 12:00 p.m.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="alert alert-danger bg-white mt-2"
                                    role="alert"
                                  >
                                    <span className="fw-medium">
                                      <i className="bi bi-credit-card text-upch me-1" />{" "}
                                      Puedes pagar con tarjeta de crédito,
                                      débito o efectivo.
                                    </span>{" "}
                                    <br />
                                  </div>
                                  <p />
                                </div>
                              </div>

                              <div className="text-center mt-3">
                                <button
                                  type="button"
                                  className="btn waves-effect waves-light btn-light-secondary bg-black previous mb-4"
                                  onClick={validarBtnPagoDespues}
                                >
                                  {pago_pagar_despues}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default PagoPensiones;
